export default __webpack_public_path__ + "static/media/ainn.05962352.jpg";